import { Input } from "antd";
import React from "react";

const getColorBasedOnValue = (value, alarm_Data) => {
  const numValue = parseFloat(value);
  switch (true) {
    case numValue < alarm_Data?.orange:
      return "green";
    case numValue >= alarm_Data?.orange && numValue < alarm_Data?.red:
      return "orange";
    case numValue >= alarm_Data?.red && numValue <= alarm_Data?.max:
      return "red";
    default:
      return "grey";
  }
};

// AlramInput Component
function AlramInput({ placeholder, value, onChange, alarm_Data, disabled }) {
  const color = getColorBasedOnValue(value, alarm_Data);
  return (
    <Input
      disabled={disabled}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      style={{
        borderColor: color,
        borderWidth: "1.5px",
        borderStyle: "solid",
        color: color,
      }}
    />
  );
}

export default AlramInput;
